// Labels and limits of the Source Field tab. They mirror reminder_setup/source_field/controller.js.

export const MAX_FIELDS = 300;
export const FIELD_KEY_RE = /^[a-z][a-z0-9_]{0,62}$/;
export const DATE_TYPES = ["DATE", "TIMESTAMP"];
// Roles a source may hold once; a computed value can hold none of them.
export const SINGLE_ROLES = ["SUBJECT", "REFERENCE", "PROJECT_REF"];
// Data types each role accepts (ATTRIBUTE accepts any).
export const ROLE_TYPES = {
  SUBJECT: ["INT"],
  REFERENCE: ["INT", "TEXT"],
  USER_REF: ["INT", "INT_ARRAY"],
  EMAIL_REF: ["TEXT", "TEXT_ARRAY"],
  PROJECT_REF: ["INT"],
};

export const FORMAT_LABEL = {
  date: "Date",
  datetime: "Date & time",
  time: "Time",
  currency: "Currency",
  number: "Number",
  "number:2": "Number (2 dp)",
  percent: "Percent",
};
export const FORMAT_OPTIONS = Object.entries(FORMAT_LABEL).map(([value, label]) => ({ value, label }));

export const COMPUTE_OP_LABEL = {
  add_days: "Add days to a date",
  add_months: "Add months to a date",
  add_years: "Add years to a date",
  diff_days: "Days between two dates",
  years_between: "Whole years between two dates",
  count_relation: "Count related records",
  latest_value: "Value of the newest related record",
};
export const ADD_OPS = ["add_days", "add_months", "add_years"];
export const DIFF_OPS = ["diff_days", "years_between"];
